import * as React from 'react';


function Panel(props) {
	const {sideLength, onSideLengthChange, cityName, onCityNameChange} = props;

  return (
    <div className="panel">

      <div className="input">
        <label>Bounding Square Side Length</label>
        <input
          type="number"
          value={sideLength}
          onChange={e => onSideLengthChange(e.target.value)}
        />
      </div>

      <div className="input">
        <label>City Name Filter</label>
        <input
          type="string"
          value={cityName}
          onChange={e => onCityNameChange(e.target.value)}
        />
      </div>

    </div>
  );
}

export default React.memo(Panel);